<template>
<v-card flat class="mx-auto" tile>
    <v-row>
        <v-col cols="12" md="4">
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Company</v-list-item-title>
                    <v-list-item-subtitle>{{customer.company}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-col>
        <v-col cols="12" md="4">
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Tax ID</v-list-item-title>
                    <v-list-item-subtitle>{{customer.taxId}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-col>
        <v-col cols="12" md="4">
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Country</v-list-item-title>
                    <v-list-item-subtitle>
                        <v-chip color="grey lighten-5" small label>
                             <span :class="`flag-icon flag-icon-${customer.country.toLowerCase()} mr-2`"></span> {{customer.country}}
                        </v-chip>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-col>
        <v-col cols="12" md="4">
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Billing Address</v-list-item-title>
                    <v-list-item-subtitle>
                        City: {{customer.address.city}} <br>
                        State: {{customer.address.state}} <br>
                        Zip: {{customer.address.zip}} <br>
                        Line1: {{customer.address.line1}}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-col>
        <v-col cols="12" md="4">
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Email address</v-list-item-title>
                    <v-list-item-subtitle>{{customer.email}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-col>
    </v-row>

</v-card>
</template>

<script>
export default {
    props: ['customer']
}
</script>
